import { render } from "./Traders-services.vue?vue&type=template&id=76b3f2d0&scoped=true"
import script from "./Traders-services.vue?vue&type=script&lang=js"
export * from "./Traders-services.vue?vue&type=script&lang=js"

import "./Traders-services.vue?vue&type=style&index=0&id=76b3f2d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b3f2d0"]])

export default __exports__